<template>
  <div>
    <div class="mt-2 mb-3">
      <div class="locked-equipment-container">
        <div class="md-title">
          Status dos equipamentos
          <span class="md-subheading">(Últimas 2 horas)</span>
        </div>
        <md-progress-spinner
          v-if="loading"
          md-mode="indeterminate"
          :md-diameter="20"
          :md-stroke="3"
        />
      </div>
      <div class="md-layout mt-2 md-gutter">
        <div
          v-for="equipamento in equipamentos"
          :key="equipamento.id"
          class="md-layout-item md-small-size-33 md-size-20 mt-3"
        >
          <equipamento-status-card
            :equipamento="equipamento"
            :local-id="localId"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EquipamentoStatusCard from '@/components/equipamento/card/EquipamentoStatusCard.vue'
import http from '@/utils/http'

export default {
  name: 'DashboardEquipamentosTravados',
  components: { EquipamentoStatusCard },
  props: {
    localId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: true,
      equipamentos: [],
      intervalUpdate: null,
    }
  },
  beforeMount() {
    this.loadData()

    this.intervalUpdate = setInterval(() => {
      this.loadData()
    }, 60000)
  },
  beforeDestroy() {
    clearInterval(this.intervalUpdate)
  },
  methods: {
    async loadData() {
      this.loading = true
      this.equipamentos = (
        await http.get(`local/${this.localId}/dashboard/equipamentos-travados`)
      ).equipamentos
      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.locked-equipment-container {
  display: flex;
  gap: 7px;
  align-items: center;
}
</style>
